import { Icon } from './Icon.tsx';
import type { IconName } from './Icon.tsx';

interface Action {
  icon: IconName;
  label: string;
  onClick?: () => void;
  accent?: boolean;
  /**
   * 눌린 채로 남아 있는가 — ⋯ 로 옵션 메뉴를 펼친 동안입니다 (F3-1 · F4-4).
   *
   * 메뉴가 목록을 덮지 않으므로, 무엇을 눌러 열린 것인지는 버튼 자신이
   * 말해야 합니다.
   */
  pressed?: boolean;
}

interface Props {
  title: string;
  subtitle?: string;
  /** 탭 최상위 화면은 제목을 왼쪽에 크게 둡니다 */
  large?: boolean;
  start?: Action;
  end?: Action;
}

export function NavBar({ title, subtitle, large, start, end }: Props) {
  return (
    <header className="navbar">
      <div className="navbar__inner">
        {start ? (
          <button
            type="button"
            className={`navbar__btn${start.accent ? ' navbar__btn--accent' : ''}`}
            aria-label={start.label}
            onClick={start.onClick}
          >
            <Icon name={start.icon} />
          </button>
        ) : (
          !large && <span />
        )}

        <h1 className={large ? 'navbar__title navbar__title--start' : 'navbar__title'}>
          {title}
          {subtitle && <span className="navbar__subtitle">{subtitle}</span>}
        </h1>

        {end ? (
          <button
            type="button"
            className={
              'navbar__btn navbar__btn--end' +
              (end.accent ? ' navbar__btn--accent' : '') +
              (end.pressed ? ' navbar__btn--pressed' : '')
            }
            aria-label={end.label}
            aria-expanded={end.pressed}
            onClick={end.onClick}
          >
            <Icon name={end.icon} />
          </button>
        ) : (
          <span />
        )}
      </div>
    </header>
  );
}
